export class PublicAccordion {
    run() {
        this.eventListeners();
    }

    eventListeners() {
        window.addEventListener('click', (e) => {
            const header = e.target.closest('.accordion-section-item__header');
            if (header) {
                e.preventDefault();
                header.closest('.accordion-section-item').classList.toggle('opened');
            }
        });
    }
}